import { MSerializers } from "@legacy-megarax/serializers";

export interface BasicAddress {
  locality: string;
  street: string;
  postalCode: string;
  country: string;
}

export const addressSerializer = MSerializers.object<BasicAddress>({
  locality: MSerializers.string,
  street: MSerializers.string,
  postalCode: MSerializers.string,
  country: MSerializers.string,
});
